import styled from 'styled-components';
export var Container = styled.div.withConfig({
  displayName: "FilterBooleanstyles__Container",
  componentId: "keen-query-creator__sc-ruh5k1-0"
})(["&&&{position:relative;}"]);